
// Map

$(function () {
  $(".bavaria-map__link, .bavaria-map__area").on("mouseenter", function () {
    var id = $(this).attr("data-id");
    showMapArea(id);
  });

  $(".bavaria-map__link, .bavaria-map__area").on("mouseleave", function () {
    hideMapArea();
  });

  $(".bavaria-map__area").on("click", function () {
    var id = $(this).attr("data-id");
    window.location.href = $('.bavaria-map__link[data-id="' + id + '"]').attr(
      "href"
    );
  });
});

function showMapArea(id) {
  if (!id) {
    return;
  }

  $(
    '.bavaria-map__text[data-id="' +
    id +
    '"], .bavaria-map__area[data-id="' +
    id +
    '"], .bavaria-map__link[data-id="' +
    id +
    '"]'
  ).addClass("map-active");
}
function hideMapArea() {
  $(".bavaria-map__text, .bavaria-map__area, .bavaria-map__link").removeClass(
    "map-active"
  );
}
